import React from "react";

import { auth } from "../firebase";

/**
 * Record the signed-in session (`user_activity/{uid}`) whenever a user is
 * signed in while the caller is mounted.
 *
 * App calls this unconditionally, in every view. Admin Identity's
 * "Active (7d)", last-login and login-count columns read the record, so it
 * must not wait for the code-split simulation editor to load.
 */
export function useRecordUserSession(): void {
  React.useEffect(() => {
    let cancelled = false;
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (cancelled || !user) return;
      import("../services/userSessionService")
        .then(({ recordUserSessionBestEffort }) =>
          recordUserSessionBestEffort(user.uid),
        )
        .catch((error: unknown) => {
          console.warn("[useRecordUserSession] could not record the session", error);
        });
    });
    return () => {
      cancelled = true;
      unsubscribe();
    };
  }, []);
}
